import { combineReducers } from 'redux-immutable';
import request from './requestDuck';
import form from './formDuck';

export default combineReducers({
  request,
  form,
});
